import SiteView from 'views/site/site-view';
import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import Chaplin from 'chaplin';
import EF from 'ef/ef';

/**
 * Chaplin create the route controller as a new object, based on a class,
 * EsModules add the default property to the exported class, making the instansiation of the Controller
 * inaccesible
 * @see https://github.com/chaplinjs/chaplin/blob/49bc7d6a325f7d0d9c4ba2a497773c0cf40be5b1/src/chaplin/dispatcher.coffee#L96
 *
 * please keep controllers as requirejs modules
 */
export default Chaplin.Controller.extend({
  // Place your application-specific controller features here.
  beforeAction: function (params, route, options) {
    const model = CourseSettingsService.getModel();
    model.set('showDev', EF.options.local || options.query.showDev);
    model.set('controller', route.controller);
    const view = this.reuse('site', SiteView, {
      model: model,
      container: CourseSettingsService.get('container') || 'body',
    });
    (view.refresh || Function).call(view);
  },
});
